import { render, staticRenderFns } from "./FieldsetHeading.vue?vue&type=template&id=09dfd84b&scoped=true"
import script from "./FieldsetHeading.vue?vue&type=script&lang=js"
export * from "./FieldsetHeading.vue?vue&type=script&lang=js"
import style0 from "./FieldsetHeading.vue?vue&type=style&index=0&id=09dfd84b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09dfd84b",
  null
  
)

export default component.exports